export default __webpack_public_path__ + "static/media/question-mark-inactive.99e615fa.svg";